"use client";
import { useEffect } from "react";

export default function Datenschutz() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // wichtig!
    });
  }, []);

  return (
    <>
      <div className={"flex flex-col gap-4 items-center px-4 py-20 overflow-hidden"}>
        <div className={"flex flex-row gap-4 w-full xl:w-2/3"}>
          <h2 className="font-bold text-xl">Impressum</h2>
        </div>
        <div className={"flex flex-col gap-4 w-full xl:w-2/3"}>
          <p><strong>Gorji Software Design International GmbH</strong></p>
          <p><strong>Anschrift: </strong>Unterortstr. 36, D - 65760 Eschborn</p>
          <br/>
          <p><strong>Geschäftsführender Inhaber: </strong>Dipl. Ing. Ramin Gorji</p>
          <p><strong>Telefon: </strong>+49 (0) 6196 - 950 591 0<br/>+49 (0) 177 - 361 361 9</p>
          <p><strong>Fax: </strong>+49 (0) 6196 - 950 591 8</p>
          <p><strong>E-Mail: </strong>info@sdigroup.de</p>
          <p><strong>USt-IdNr.: </strong>DE254549143</p>
          <p><strong>Handelsregister: </strong>79886</p>
          <p><strong>Amtsgericht : </strong>Frankfurt am Main</p>
        </div>
      </div>
    </>
  );
}
